import { Typography, TypographyProps } from '@mui/material'

const RestrictionText = (props: TypographyProps) => {
  const { children, color, sx: sxProps } = props
  return (
    <Typography
      {...props}
      color={color ?? 'usageRestrictionRed'}
      sx={{ ...sxProps, hyphens: 'auto', wordBreak: 'break-word', fontSize: '15px' }}
      fontWeight="bold"
      display="flex"
    >
      {children}
    </Typography>
  )
}

export default RestrictionText
